import React from "react";
import { observer } from "mobx-react";
import { ContractObservationViewStore } from "../../store";
import { ContractObservationViewForm } from "./ContractObservationViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type ContractObservationViewProps = {
  contractObservationViewStore: ContractObservationViewStore;
};

export const ContractObservationView: React.FC<ContractObservationViewProps> =
  observer(({ contractObservationViewStore }) => {
    return (
      <div>
        <ContractObservationViewForm
          contractObservationViewStore={contractObservationViewStore}
          title={contractObservationViewStore.titleValue}
          observation={contractObservationViewStore.observationValue}
          requireAll={contractObservationViewStore.requireAllValue}
          authorsValues={contractObservationViewStore.authorsValues}
          publishersValues={contractObservationViewStore.publishersValues}
          onPrint={(handlePrint: () => void) =>
            contractObservationViewStore.printContractObservation(handlePrint)
          }
          onCancel={() =>
            contractObservationViewStore.cancelContractObservation()
          }
          onEdit={
            contractObservationViewStore.isEditEnabled
              ? () => contractObservationViewStore.editContractObservation()
              : undefined
          }
        />
        <ErrorDialog
          open={contractObservationViewStore.errorDialogOpened}
          title={contractObservationViewStore.errorTitle}
          description={contractObservationViewStore.errorDescription}
          onClose={() => contractObservationViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
